import { createFileRoute } from '@tanstack/react-router';
import { PlatformUsageMonitoringPage } from '@/modules/platform-usage/pages/PlatformUsageMonitoringPage';

export const Route = createFileRoute('/dashboard/analytics/platform-usage/')({
  component: PlatformUsageMonitoringPage,
});
